export default "__VITE_ASSET__71fe5a1a__"